// extracted by mini-css-extract-plugin
module.exports = {"headerBackground":"header_headerBackground__VL2-U","logo":"header_logo__t295o","img":"header_img__2k0R2","headerlink":"header_headerlink__3PaX0"};